import { useDispatch } from "react-redux"
import React from "react"
import {successStatus} from "../state/apiStatusSlice"
import { envAwarePost } from "../util/util"

// item = "name of item operation is being performed on"
// operation = "should be "add", "edit", or "delete", although it is possible to add custom operation, e.g: "assign"

const useApiStatusEnvAwarePost = () => {
    let dispatch = useDispatch();
    const wrappedEnvAwarePost = (url,payload, item, operation) => {
        return envAwarePost(url, payload).then(res => {
            res.success === '1' ? dispatch(successStatus({item, operation, success:true})) 
            : dispatch(successStatus({item, operation,success:false,message:res.message}))
            return res
        })
    }
    return wrappedEnvAwarePost
}
export default useApiStatusEnvAwarePost;